module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search":"Search..."},"de":{"search":"Suchen..."},"fr":{"search":"Rechercher..."},"it":{"search":"Ricerca..."}}')
  delete Component.options._Ctor
}
